<!--
 * @Author: 首页
 * @Date: 2020-07-23 09:52:48
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 15:23:08
 * @FilePath: \car-demo\src\views\Home.vue
-->
<template>
  <div class="custom-form">
    <FixedTool />
		<div class="banner"></div>
    <Advertise
        height="100px"
        href="http://www.baidu.com"
        target="_blank"
        :imgSrc="require('@/assets/images/demo-panel.png')"
    />

    <h1 v-if="data && data.info">{{ data.info.name }}</h1>

    <form id="form">
      <!--  表单一   -->
      <div v-if="data && data.forms && data.forms.length" v-for="item in data.forms">
        <h2 v-if="item.is_show">{{ item.title }}</h2>
        <div v-if="item.is_show">
          <div v-for="form in item.form" :key="form.id">
            <label :for="'from' + form.id">
              <em v-if="parseInt(form.is_require) === 1" class="is-require">*</em>
              {{ form.ele_title }}
            </label>
          <div class="input_code" v-html="form.input_code"></div>
        </div>
        </div>
      </div>
    </form>

    <button @click="submit" id="submit">提交表单</button>

    <ul class="footer">
      <li>如有任何疑问请联系我们</li>
      <li>
        电话： <a href="tel://" class="tel">{{ conf.card_phone }}</a>
        微信：<a href="javascript:" class="tel" @click="copy(conf.card_wechat)">{{ conf.card_wechat }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import Advertise from '@/components/Advertise'

import $ from 'jquery'
import {Toast} from '@nutui/nutui'
import cache from "../utils/cache";

function isPhoneNo(phone) {
  var pattern = /^1[3456789]\d{9}$/
  return pattern.test(phone)
}

export default {
  metaInfo: {
    title: '在线投诉',
    titleTemplate: null,
  },
  data: () => ({
        data: {},
        forms: {},
        conf: {},
      }
  ),
  components: {
    Advertise,
  },
  created() {
    if (this.$route.query.id) {
      cache.set('custom_form_id', this.$route.query.id);
      this.getForm(this.$route.query.id)
    } else if (this.$route.query.id) {
      this.getForm(this.$route.query.id)
    } else {
      this.getForm(cache.get('custom_form_id'));
    }

    this.getConf()
  },
  methods: {
    getConf() {
      this.$ajax.get('m/system/conf').then(res => {
        this.conf = res;
      })
    },
    getForm(id) {

      this.$ajax
          .get('m/complaint/index', {
            activity_id: this.$ajax.get_activity_id(),
            id: id,
          })
          .then((res) => {
            this.data = res;
            //表单分享信息写入
            this.shareDiyRead(res,id);
          })
    },
    //分享自定义
    shareDiyRead(data,id){
      if(data.info.share_img){
        window.shareConf.fx_pic = data.info.share_img;
      }
      if(data.info.name){
        window.shareConf.fx_title = data.info.name;
      }
      if(data.info.share_desc){
        window.shareConf.fx_memo = data.info.share_desc
      }
      window.shareConf.fx_url = window.location.href+'?id='+id;
      shareDiy();
    },
    submit() {
      let is_valid = true
      $('.input_ele').each(function (i, e) {
        let ele = $(e)

        let required = ele.attr('required'),
            msg = ele.attr('tip'),
            tag = ele.attr('tag'),
            val = $.trim(ele.val())

        if (required && !val) {
          is_valid = false
          Toast.text(msg)
          return false
        }
        if (tag === 'mobile' && required && isPhoneNo(val) === false) {
          is_valid = false
          this.$toast.text('手机号码不正确')
          return false
        }
      })

      if (is_valid) {
        let data = $('#form').serializeArray()
        this.$ajax.post('m/trade/complaint_collect', data).then((res) => {

          this.$toast.text('提交成功,感谢您的参与');
          setTimeout(() => {
            this.$router.push({name: 'Home'})
          }, 2000)
        })
      }
    },
    copy(text){
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', text)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$toast.text('复制成功');
      }
      document.body.removeChild(input)
    }
  }
  ,
}
</script>

<style lang="less" scoped>
.input_code{
  ::v-deep{
    img{width: 100%;}
  }
}

.is-require {
  color: red;
}

.custom-form {
  padding: 10px 14px;
}

.banner {
			width: 100%;
			height: 68px;
			background-image: url(../assets/images/find_d_banner.png);
			background-color: #2B82ED;
			box-sizing: border-box;
			padding-left: 43px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			color: #fff;
		}

// 表单
#form {
  /deep/ input.input_ele {
    width: 100% !important;
    padding: 8px 5px;
    outline: none;
    border: 0;
  }

  /deep/ select.input_ele {
    width: 100%;
    border: 0;
    outline: none;
    background-color: #ffffff;
  }

  /deep/ textarea.input_ele {
    width: 100%;
    border: 0;
    outline: none;
    padding: 8px 5px;
  }

  h2 {
    font-size: 15px;
    color: #333333;
    font-weight: bold;
    margin: 20px 0;
  }

  h2 ~ div {
    padding: 5px 0;
    border-bottom: 1px solid #e2e2e2;
  }

  label {
    display: block;
    font-size: 14px;
    margin-bottom: 6px;
  }
}

/deep/ button#submit {
  display: block;
  width: 100%;
  height: 40px;
  background: linear-gradient(222deg,
  rgba(0, 194, 255, 1) 0%,
  rgba(60, 67, 236, 1) 100%);
  border-radius: 25px;
  border: 0;
  margin-top: 40px;
  margin-bottom: 30px;
  font-size: 15px;
  color: #ffffff;
  font-weight: bold;
  appearance: none;
  outline: none;
}

.footer {
  font-size: 12px;
  color: #999999;
  text-align: center;
  line-height: 1.5em;

  .tel {
    &:first-child {
      margin-right: 10px;
    }

    text-decoration: underline;
  }
}
</style>
